import React from "react";
import Navbar from '../components/navbar/Navbar';
import Body from '../components/body/Body';
const Home = () => {
  return (
    <div>
        <Navbar />
        <Body />
    </div>
  );
};

export default Home;